document.addEventListener('DOMContentLoaded', function () {

  // CUSTOM CURSOR
  const cursor = document.getElementById('oh-cursor');
  const ring   = document.getElementById('oh-cursor-ring');
  if (cursor && ring) {
    let mx=0, my=0, rx=0, ry=0;
    document.addEventListener('mousemove', e => { mx=e.clientX; my=e.clientY; cursor.style.left=mx-6+'px'; cursor.style.top=my-6+'px'; });
    setInterval(() => { rx+=(mx-rx)*0.12; ry+=(my-ry)*0.12; ring.style.left=rx-18+'px'; ring.style.top=ry-18+'px'; }, 16);
    document.querySelectorAll('button,a,.oh-product-card,.oh-mc-card,.oh-mdot,.oh-thumb,.oh-upsell-card').forEach(el => {
      el.addEventListener('mouseenter', () => { cursor.style.transform='scale(2)'; cursor.style.background='var(--neon2)'; });
      el.addEventListener('mouseleave', () => { cursor.style.transform='scale(1)'; cursor.style.background='var(--neon)'; });
    });
  }

  // SCROLL REVEAL
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(r => obs.observe(r));

  // EMAIL POPUP
  const popup = document.getElementById('oh-popup');
  if (popup && !sessionStorage.getItem('oh_popup_seen')) {
    setTimeout(() => popup.classList.add('visible'), 3500);
  }
  document.querySelectorAll('[data-close-popup]').forEach(el => {
    el.addEventListener('click', () => { popup.classList.remove('visible'); sessionStorage.setItem('oh_popup_seen','1'); });
  });
  if (popup) popup.addEventListener('click', e => { if (e.target===popup) { popup.classList.remove('visible'); sessionStorage.setItem('oh_popup_seen','1'); } });

  const submitBtn = document.getElementById('oh-popup-submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      const input = document.getElementById('oh-popup-email');
      if (!input.value || !input.value.includes('@')) { input.style.borderColor='var(--neon2)'; input.placeholder='Enter a valid email!'; return; }
      popup.classList.remove('visible');
      sessionStorage.setItem('oh_popup_seen','1');
      showNotif('✓', '<strong>You\'re in the clan!</strong>Check email for 10% off.', 'var(--neon)');
    });
  }

  // TOAST NOTIFICATION
  window.showNotif = function(icon, html, borderColor) {
    const n = document.getElementById('oh-notif');
    if (!n) return;
    n.querySelector('.oh-notif-icon').textContent = icon;
    n.querySelector('.oh-notif-text').innerHTML = html;
    if (borderColor) n.style.borderColor = borderColor;
    n.classList.add('show');
    setTimeout(() => n.classList.remove('show'), 3500);
  };

  // MASCOT SWITCHER
  const mascots = [
    { e:'🐉', name:'AYA',    role:'THE EDGE'   },
    { e:'⚡',  name:'RIZU',   role:'THE ENERGY' },
    { e:'🌙',  name:'REN',    role:'THE DEPTH'  },
    { e:'🔥',  name:'HARUKI', role:'THE SOUL'   },
  ];
  window.switchMascot = function(i, el) {
    document.querySelectorAll('.oh-mdot').forEach(d => d.classList.remove('active'));
    el.classList.add('active');
    const m = mascots[i];
    const em = document.getElementById('oh-hero-mascot');
    if (!em) return;
    em.style.transition='transform 0.2s'; em.style.transform='scale(0)';
    setTimeout(() => { em.textContent=m.e; document.getElementById('oh-mascot-name').textContent=m.name; document.getElementById('oh-mascot-role').textContent=m.role; em.style.transform=''; }, 200);
  };

  // SIZE SELECTOR + VARIANT UPDATE
  document.querySelectorAll('.oh-sz').forEach(btn => {
    btn.addEventListener('click', function() {
      if (this.classList.contains('soldout')) return;
      const group = this.closest('.oh-size-grid') || this.closest('.oh-size-row');
      if (group) group.querySelectorAll('.oh-sz').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // GALLERY THUMBS
  document.querySelectorAll('.oh-thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.oh-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

});